import { TaxExemption, TaxExemptionCreateData } from "@/types/tax-exemption";

export async function createTaxExemption(
  data: TaxExemptionCreateData,
): Promise<TaxExemption> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  const response = await fetch("/api/tax-exemption", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  });

  clearTimeout(timeoutId);

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.error || "Failed to create organization tax exemption",
    );
  }

  try {
    const { taxExemption } = await response.json();
    return taxExemption;
  } catch (error: any) {
    throw new Error(
      error.message || "Failed to create organization tax exemption",
    );
  }
}

export async function getTaxExemption(
  organizationId: string,
  forceRefresh = false,
): Promise<TaxExemption | null> {
  const url = forceRefresh
    ? `/api/tax-exemption?orgId=${organizationId}&_=${Date.now()}`
    : `/api/tax-exemption?orgId=${organizationId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    cache: forceRefresh ? "no-store" : "force-cache",
    next: forceRefresh
      ? undefined
      : {
          tags: ["tax-exemption"],
          revalidate: 3600,
        },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.error || "Failed to get organization tax exemption",
    );
  }

  try {
    const { taxExemption } = await response.json();
    return taxExemption;
  } catch (error: any) {
    throw new Error(
      error.message || "Failed to get organization tax exemption",
    );
  }
}
